module.exports = __webpack_public_path__ + "img/calen.2ac987e8.svg";